// const Baseurl = "http://localhost:5001"
const Baseurl = "https://api.imoxkitchen.com"
export { Baseurl }
